export default {
  PROFILE_UPDATED: "Profil modifié",
};
